export function handlePaste(clipboardEvent: ClipboardEvent, allowed: RegExp) {
  clipboardEvent.preventDefault();
  const pastedInput: string = clipboardEvent.clipboardData?.getData('text/plain').replace(allowed, '') ?? '';

  const selection = window.getSelection();
  if (!selection?.rangeCount) return;

  const range = selection.getRangeAt(0);
  range.deleteContents();

  const textNode = document.createTextNode(pastedInput);
  range.insertNode(textNode);
  range.setStartAfter(textNode);
  range.setEndAfter(textNode);
  selection.removeAllRanges();
  selection.addRange(range);
}

export function allowOnlyNumbers(event: KeyboardEvent, allowedKeys: string[]) {
  const isCtrlCombo = (event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());

  const isAllowedKey = allowedKeys.includes(event.key) || isCtrlCombo || event.key === 'Tab';

  if (!isAllowedKey && isNaN(Number(event.key))) {
    event.preventDefault();
  }
}

export function onKeyDown(keyBoardEvent: KeyboardEvent) {
  const allowedKeys = ['ArrowLeft', 'ArrowRight', 'Delete', 'Backspace', 'Space'];
  allowOnlyNumbers(keyBoardEvent, allowedKeys);
}

export function onPaste(clipboardEvent: ClipboardEvent) {
  clipboardEvent.preventDefault();
  const pastedInput: string = clipboardEvent.clipboardData?.getData('text/plain').replace(/\D/g, '') ?? '';

  const selection = window.getSelection();
  if (!selection?.rangeCount) return;

  const range = selection.getRangeAt(0);
  range.deleteContents();

  const textNode = document.createTextNode(pastedInput);
  range.insertNode(textNode);
  range.setStartAfter(textNode);
  range.setEndAfter(textNode);
  selection.removeAllRanges();
  selection.addRange(range);
}
